export function env(key: string): string {
    const val = process.env[key]
    if(val === undefined) {
        throw Error('Tried access non set environment variable: ' + key)
    }
    return val
}
